import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IAssetsOpensea } from "../models/opensea-model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OpenseaService {
  private OpenseaURL = "https://api.opensea.io/api/v1";
  constructor(private http: HttpClient) {}
  public getAssets(
    order_direction: string,
    collection: string,
    offset: number,
    limit: number,
    order_by?: string
  ): Observable<{ assets: IAssetsOpensea[] }> {
   return this.http.get<{ assets: IAssetsOpensea[] }>(
      `${this.OpenseaURL}/assets?order_by=sale_price&order_direction=${order_direction}&limit=${limit}&collection=${collection}`,
      {
        headers: {
          Anonymous: "Anonymous",
          'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/50.0.2661.102 Safari/537.36'
        },
      }
    );
  }
  public getSingleAsset(
    asset_contract_address: string,
    token_id: string
  ): Observable<IAssetsOpensea> {
    return this.http.get<IAssetsOpensea>(
      `${this.OpenseaURL}/asset/${asset_contract_address}/${token_id}/`,
      {
        headers: {
          Anonymous: "Anonymous",
        },
      }
    );
  }
}
